import React, { useEffect } from "react";

import { BrandLockup } from "../BrandLockup";
import { ButtonLink } from "../../../components/ButtonLink/ButtonLink";
import { loadHotmartScript } from "../../../components/HotmartCheckoutButton/HotmartCheckoutButton";
import { cn } from "../../../utils/cn";
import { janela, notaAssinatura, planos } from "../../../utils/copy";
import fotoColar from "../../../assets/images/ConversasTerapeuticas/colar.jpeg";

export function Investimento() {
  // o script da Hotmart varre o DOM por .hotmart-fb uma única vez, no load —
  // por isso a classe já precisa estar no elemento desde a primeira renderização,
  // e não só depois que o script termina de carregar
  useEffect(() => {
    loadHotmartScript().catch(() => console.error("Erro ao carregar script da Hotmart"));
  }, []);

  return (
    <section id="investimento" data-bg="#ece3d7" className="poster-section investment-section">
      <BrandLockup />

      <div className="investment-intro">
        {/* pedido da Manuela (23/07): o título volta a ser "A turma de 2026",
            como no build antigo, e o parágrafo do colar dá lugar à explicação
            da cobrança. O colar não some da página: continua no card do anual
            (item da lista + selo "só a turma fundadora recebe"). */}
        <h2 data-motion="title"><span className="type-display">A turma</span> <em className="type-voice">de 2026</em><span aria-hidden="true" className="investment-star">*</span></h2>
        <p data-motion="lead" className="investment-terms">{notaAssinatura}</p>
        {/* a escassez real da turma (copy.ts), que existia escrita e não era
            renderizada em lugar nenhum. Entra antes dos planos: é a razão de
            decidir agora, e sem ela o preço aparece sem contexto de prazo. */}
        <p data-motion="lead" className="investment-window">{janela}</p>
      </div>

      {/* sem role/tabIndex: os dois vieram do padrão axe scrollable-region-focusable,
          quando o palco era carrossel horizontal no mobile. Hoje ele empilha em
          coluna, não rola, e a parada de tabulação só atrapalhava quem usa teclado. */}
      <div className="investment-stage">
        <article className="annual-card">
          <p className="plan-tag">{planos.anual.tag}</p>
          <p className="type-voice annual-seal">{planos.anual.selo}</p>
          <div className="annual-price"><strong className="type-display">{planos.anual.preco}</strong><span className="type-display">{planos.anual.detalhe}</span></div>
          <p className="annual-discount">{planos.anual.sub}</p>
          <ul>
            {planos.anual.itens.map((item) => <li key={item}><span aria-hidden="true">✱</span>{item}</li>)}
          </ul>
          <div className="necklace-reference" role="img" aria-label="Colar exclusivo entregue à turma fundadora">
            <img src={fotoColar} alt="" className="h-full w-full object-cover" />
            <em className="type-voice">só a turma<br />fundadora<br />recebe</em>
          </div>
          <ButtonLink
            variant="solid"
            href="https://pay.hotmart.com/J107095860V?checkoutMode=2"
            className={cn("annual-cta", "hotmart-fb hotmart__button-checkout")}
          >
            {planos.anual.cta}
          </ButtonLink>
          {/* texto legal dentro do box, logo abaixo do CTA (doc jul/2026) */}
          <p className="plan-legal"><span aria-hidden="true">*</span>{planos.anual.notaLegal}</p>
        </article>

        <article className="quarter-card">
          <p className="plan-tag">{planos.trimestral.tag}</p>
          <h3 className="sr-only">Plano {planos.trimestral.nome}</h3>
          <div className="quarter-price"><strong className="type-display">{planos.trimestral.preco}</strong><span className="type-display">{planos.trimestral.detalhe}</span></div>
          <ul className="quarter-itens">
            {planos.trimestral.itens.map((item) => <li key={item}><span aria-hidden="true">✱</span>{item}</li>)}
          </ul>
          <ButtonLink
            variant="solid"
            href="https://pay.hotmart.com/Q106049633B?checkoutMode=2"
            className={cn("quarter-cta", "hotmart-fb hotmart__button-checkout")}
          >
            {planos.trimestral.cta}
          </ButtonLink>
          <p className="plan-legal"><span aria-hidden="true">*</span>{planos.trimestral.notaLegal}</p>
        </article>
      </div>

      <p className="investment-meta">Um ano · encontros ao vivo · entre mulheres</p>
    </section>
  );
}
